var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.41 4.67a5.8 5.8 0 00-3.22-3.23A14 14 0 0016.55 1h-9.1a8.4 8.4 0 00-2.64.44 5.8 5.8 0 00-3.22 3.23A10.2 10.2 0 001 7.45v9.1a8.4 8.4 0 00.44 2.64 5.8 5.8 0 003.23 3.22 9.23 9.23 0 002.78.59h9.1a5.76 5.76 0 002.64-.59 5.79 5.79 0 003.22-3.22A8.41 8.41 0 0023 16.4V7.31a5.76 5.76 0 00-.59-2.64zM21 16.25a5.27 5.27 0 01-.44 2.06 3.55 3.55 0 01-2.06 2.05 4.71 4.71 0 01-2.05.44H7.6a5.22 5.22 0 01-2-.44 3.55 3.55 0 01-2.06-2.05 4.75 4.75 0 01-.44-2.06v-8.8a5.22 5.22 0 01.44-2 4.64 4.64 0 012.01-2.1 8.42 8.42 0 012.05-.3c1.32 0 1.47-.14 4.4-.14h4.4a5 5 0 012.05.44 3.55 3.55 0 012.06 2.05A4.74 4.74 0 0121 7.45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.28A5.6 5.6 0 006.43 12 5.6 5.6 0 0012 17.72a5.72 5.72 0 000-11.44zm0 9.39A3.67 3.67 0 1115.67 12 3.64 3.64 0 0112 15.67zm5.87-10.86a1.32 1.32 0 101.32 1.32 1.32 1.32 0 00-1.32-1.32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}

export default SvgInstagram;